import { createContext, useContext } from 'react'

import { BankUsersReportFilterParams, BankUsersReportResponse } from '~bank-reports/types/BankUsersReport'

type UserReportContextValue = {
  data: BankUsersReportResponse
  isPending: boolean
  successFullyLoaded: boolean
  state: BankUsersReportFilterParams
  navigate: (searchParams: Partial<BankUsersReportFilterParams>) => Promise<void>
  clear: () => void
}

export const UserReportContext = createContext<UserReportContextValue | null>(null)

export const useUserReportContext = () => {
  const context = useContext(UserReportContext)
  if (!context) {
    throw new Error('useUserReportContext must be used within a UserReportContext.Provider')
  }
  return context
}
